import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from "./view/login";
import NewUser from "./view/new-user";
import store from "./store";
import { Provider } from "react-redux";
// import Freight from "./view/frete";
import FreightList from "./view/frete-list";
import FreightListCopy from "./view/frete-list-copy";
import FreightControlPanel from "./view/freight-control-panel";
import BudgetList from "./view/budget-list/budget-list.js";
import Budget from "./view/budget/insert-budget.js";
import DriverList from "./view/driver-list";
import Driver from "./view/driver";
import UserList from "./view/user-list/user-list";
import UploadCsv from "./view/preparingDriver";
import EmbarcadorList from "./view/embarcador-list";
import NewEmbarcador from "./view/embarcador";
import MyDriverList from "./view/my-driver-list";
import MyDriver from "./view/my-driver";
import NewClient from "./view/client";
import ClientList from "./view/client-list";
import NewVehicle from "./view/vehicle";
import VehicleList from "./view/vehicle-list";
import ImportXml from "./view/importXml";
import Acompanhamento from "./view/acompanhamento";
import ViwerMapsOld from "./view/viewerFreights_old";
import DetalheDoFrete from "./view/acompanhamento/detalhe";
import ViewerFreightsOld from "./view/viewerFreightsDetail_old/viewerFreight";
import NewOcurrence from "./view/ocurrence/insert-ocurrence";
import OcurrenceList from "./view/ocurrence/list-ocurrence";
import PaymentListDetail from "./view/payment/list-payment";
import PaymentList from "./view/payment/listPayment";
import PriceTableList from "./view/priceTable/price-table-list";
import PriceTableICMS from "./view/tableIcms/table-icms";
import DashboardHome from "./view/dashboard-home/dashboard-home";
import MdfeFormTabs from "./view/manifesto/Mdfe/manifest";
import MdfeListView from "./view/manifesto/Mdfe/list-mdf-e";
import PerfilList from "./view/perfil/listPerfil";
import CreatePerfil from "./view/createPerfil/createPerfil";
import { ConfigProvider } from "antd";
import ptBR from "antd/es/locale/pt_BR";
import GroupForm from "./view/group/formScreenGroup";
import FreightCopy from "./view/frete-copy";
import GroupPage from "./view/group";
import ProductList from "./view/product/product-list.js";
import Product from "./view/product/Product.js";
import RelGeneral from "./view/rels/rel-general/rel-general";
import RelatoriosDeAcompanhamento from "./view/acompanhamento/relatorios";
import PaymentCondition from "./view/payment-condition/index.js";
import PaymentConditionForm from "./view/payment-condition/formScreenPaymentCondition.js";
import PublicTrackPage from "./view/public-track";
import DashboardVendedores from "./view/dashboard-vendedores";
import FreightSimulationPage from "./view/FreightSimulation/index.js";
import RevenuePage from "./view/revenue";
import LancesPage from "./view/lances";
import FilasTransportadorasPage from "./view/filas-transportadoras";


function App() {
  return (
    <ConfigProvider locale={ptBR}>
      <Provider store={store} >
        <BrowserRouter> 
          <Routes>
            <Route exact path="/" element={<DashboardHome />} />
            <Route exact path="/login" element={<Login />} />

            <Route exact path="/newUser" element={<NewUser />} />
            <Route exact path="/newUser/:id" element={<NewUser />} />
            <Route exact path="/userList" element={<UserList />} />

            {/* <Route exact path="/freight" element={<Freight />} />
            <Route exact path="/freight/:id" element={<Freight />} />
            <Route exact path="/freightlist" element={<FreightList />} /> */}

            <Route exact path="/budget/list" element={<BudgetList />} />
            <Route exact path="/budget" element={<Budget />} />
            <Route exact path="/budget/:id" element={<Budget />} />

            <Route exact path="/freightlistCopy" element={<FreightListCopy />} />
            <Route exact path="/freightCopy" element={<FreightCopy />} />
            <Route exact path="/freightCopy/:id" element={<FreightCopy />} />

            <Route exact path="/freightControlPanel" element={<FreightControlPanel />} />

            <Route exact path="/simulation" element={<FreightSimulationPage />} />
            <Route exact path="/lances" element={<LancesPage />} />
            <Route exact path="/minhas-candidaturas" element={<Navigate to="/lances" replace />} />
            <Route exact path="/filas-transportadoras" element={<FilasTransportadorasPage />} />

            <Route exact path="/driverList" element={<DriverList />} />
            <Route exact path="/driverList/:id" element={<Driver />} />
            <Route exact path="/driver" element={<Driver />} />

            <Route exact path="/prepareDriver" element={<UploadCsv />} />

            <Route exact path="/embarcador" element={<EmbarcadorList />} />
            <Route exact path="/newEmbarcador/:id" element={<NewEmbarcador />} />
            <Route exact path="/newEmbarcador" element={<NewEmbarcador />} />

            <Route exact path="/myDriverList/" element={<MyDriverList />} />
            <Route exact path="/myDriverList/:id" element={<MyDriver />} />
            <Route exact path="/myDriver" element={<MyDriver />} />

            <Route exact path="/clientList/" element={<ClientList />} />
            <Route exact path="/client/:id" element={<NewClient />} />
            <Route exact path="/client" element={<NewClient />} />

            <Route exact path="/vehicleList" element={<VehicleList />} />
            <Route exact path="/vehicle/:id" element={<NewVehicle />} />
            <Route exact path="/vehicle" element={<NewVehicle />} />

            <Route exact path="/freightsDetail" element={<Acompanhamento />} />
            {/* tela antiga viva ate o aceite, no mesmo lugar de sempre com sufixo -old */}
            <Route exact path="/freightsDetail-old" element={<ViwerMapsOld />} />
            <Route exact path="/freightsDetail/:id/:idDriver" element={<DetalheDoFrete />} />
            <Route
              exact
              path="/freightsDetail-old/:id/:idDriver"
              element={<ViewerFreightsOld />}
            />

            <Route exact path="/importFile" element={<ImportXml />} />

            <Route exact path="/newOcurrence" element={<NewOcurrence />} />
            <Route exact path="/newOcurrence/:id" element={<NewOcurrence />} />
            <Route exact path="/listOcurrence" element={<OcurrenceList />} />

            <Route exact path="/listPayment" element={<PaymentList />} />
            <Route exact path="/listPaymentDetail" element={<PaymentListDetail />} />

            <Route exact path="/listPerfil" element={<PerfilList />} />
            <Route exact path="/createPerfil" element={<CreatePerfil />} />
            <Route exact path="/createPerfil/:id" element={<CreatePerfil />} />

            <Route exact path="/Faturamento" element={<RevenuePage />} />

            <Route exact path="/tableIcmsList" element={<PriceTableICMS />} />
            <Route exact path="/priceTableList" element={<PriceTableList />} />

            <Route exact path="/insertMdfe" element={<MdfeFormTabs />} />
            <Route exact path="/insertMdfe/:id" element={<MdfeFormTabs />} />
            <Route exact path="/listMdfe" element={<MdfeListView />} />
            {/* camino nova tela*/}
            <Route exact path="/group" element={<GroupPage />} />
            <Route exact path="/group/new" element={<GroupForm />} />
            <Route exact path="/group/edit/:id" element={<GroupForm />} />

            <Route exact path="/productList" element={<ProductList />} />
            <Route exact path="/product" element={<Product />} />
            <Route exact path="/product/:id" element={<Product />} />

            <Route exact path="/paymentCondition" element={<PaymentCondition />} />
            <Route exact path="/paymentCondition/new" element={<PaymentConditionForm />} />
            <Route exact path="/paymentCondition/edit/:id" element={<PaymentConditionForm />} />

            <Route exact path="/acompanhamento/relatorios" element={<RelatoriosDeAcompanhamento />} />
            <Route exact path="/relGeneral" element={<RelGeneral />} />
            <Route exact path="/dashboardVendedores" element={<DashboardVendedores />} />
            <Route exact path="/track/:token" element={<PublicTrackPage />} />

          </Routes>
        </BrowserRouter>
      </Provider>
    </ConfigProvider>
  );
}

export default App;



